/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';

import { ResponsiveOverlay } from 'components/Blocks/Overlays';
import { IconButton } from 'components/Blocks/Buttons';

import { cn } from 'styles';

interface ActionTriggerProps {
  children: ReactNode;
  icon: ReactNode;
  isActive?: boolean;
  onOpen?: () => void;
}

export function TableAction({ children, icon, isActive, onOpen }: ActionTriggerProps): JSX.Element {
  return (
    <ResponsiveOverlay
      default="pop-over"
      align="start"
      className="shadow-sm"
      trigger={
        <IconButton className={cn('p-0.5', isActive && 'text-primary')} onClick={onOpen}>
          {icon}
        </IconButton>
      }
    >
      {children}
    </ResponsiveOverlay>
  );
}
